import React, { useState } from 'react';
import ReactTooltip from 'react-tooltip';
import RequiredMark from 'shared/inputs/RequiredMark';
import get from 'lodash/get';

/**
 * @deprecated Use Telerik or shared components instead.
 */
const Toggle = ({
  onToggle,
  disabled,
  disabledMessage,
  value,
  label = '',
  onText = 'ON',
  offText = 'OFF',
  errors,
  touched,
  touchedNested,
  onTouch,
  wrapperClass,
  name,
  required,
  nullable,
}) => {
  const [active, setActive] = useState(value);

  const handleToggle = () => {
    let newActive = !active;

    if (nullable && active === false) {
      newActive = null;
    }

    onToggle(newActive);
    setActive(newActive);
    if (onTouch) {
      onTouch();
    }
  };

  const noValue = nullable && (active === null || active === undefined);
  const hasError = get(errors, name) && (touchedNested || get(touched, name));

  let buttonClass = 'toggled-null';
  if (!noValue) {
    buttonClass = active ? null : 'toggled-off';
  }

  return (
    <div className={`formik-wrapper toggle ${wrapperClass || ''}`}>
      <div className='refresh-toggle'>
        <span className='label' style={{ marginBottom: '.5rem' }}>
          {label}
          {' '}
          {required && <RequiredMark />}
        </span>
        <>
          {disabled && disabledMessage && <ReactTooltip className='gwi-tooltip' multiline={false} />}
          <button
            type='button'
            disabled={disabled}
            className={`button ${buttonClass}`}
            onClick={() => handleToggle()}
          >
            {noValue ? null : active ? onText : offText}
            <span className='refresh-toggle-switch' />
          </button>
        </>
        {hasError && <div className='feedback'>{get(errors, name)}</div>}
      </div>
    </div>
  );
};

export default Toggle;
